import { OptionalVars, Variables } from "./vars";

export { getAPIHost, getAPIUrl, getAPIOrigin } from "./getApiHost";

export { getRemoHost, getRemoUrl } from "./getRemoHost";

export const getVar = <T extends Variables>(name: T) =>
  process.env[name] as T extends OptionalVars ? string | undefined : string;
